import { render, staticRenderFns } from "./areaClass.vue?vue&type=template&id=4305cafa&scoped=true&"
import script from "./areaClass.vue?vue&type=script&lang=js&"
export * from "./areaClass.vue?vue&type=script&lang=js&"
import style0 from "./areaClass.vue?vue&type=style&index=0&id=4305cafa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4305cafa",
  null
  
)

component.options.__file = "areaClass.vue"
export default component.exports